import { render, staticRenderFns } from "./homes.vue?vue&type=template&id=0081781f&scoped=true"
import script from "./homes.vue?vue&type=script&lang=js"
export * from "./homes.vue?vue&type=script&lang=js"
import style0 from "./homes.vue?vue&type=style&index=0&id=0081781f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0081781f",
  null
  
)

export default component.exports